module.exports = __webpack_public_path__ + "static/media/weather.24306ef9.png";